import React from 'react';

const NotFound = () => {
  return (
    <div className='d-flex' style={{height: '100vh'}}>
      <div className='m-auto text-center'>
        <h1 className='x-large text-primary'>
          <i className='fas fa-exclamation-triangle' /> Page Not Found
        </h1>
        <p className='large'>Sorry, this page does not exist</p>
        
      </div>
    </div>
  );
};

export default NotFound;
